(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-recent-blog-swiper]').forEach((wrapper) => {
      if (!wrapper.querySelector('.swiper-wrapper')) {
        return;
      }

      const sectionId = wrapper.dataset.sectionId;
      const enableNavigation = wrapper.dataset.enableNavigation === 'true';

      const config = {
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      };

      const paginationEl = wrapper.querySelector('.swiper-pagination');
      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }

      if (enableNavigation && sectionId) {
        config.navigation = {
          nextEl: wrapper.querySelector(`.swiper-button-next-${sectionId}`),
          prevEl: wrapper.querySelector(`.swiper-button-prev-${sectionId}`),
        };
      }

      new Swiper(wrapper, config);
    });
  });
})();
